import React from "react";
import { Select, MenuItem, IconButton, Grid, Typography, Box, Fade } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const CustomPagination = ({ currentPage, pageSize, totalRecords, handlePageChange, handlePageSizeChange, totalPages }) => {
    const serialNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

    return (
        
        <Fade in timeout={500}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 20px",
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
                    marginTop: "1.5%",
                    minHeight: "55px",
                }}
            >
                    {/* Rows per Page Selector */}
                    <Grid item sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <Typography sx={{ fontSize: "14px", fontWeight: 500, color: "#333" }}>
                            Rows per page:
                        </Typography>
                        <Select
                            variant="outlined"
                            value={pageSize}
                            onChange={handlePageSizeChange}
                            sx={{
                                fontSize: "14px",
                                height: "36px",
                                minWidth: "75px",
                                backgroundColor: "#f8f8f8",
                                borderRadius: "6px",
                                boxShadow: "none",
                                transition: "0.2s ease-in-out",
                                "&:hover": { backgroundColor: "#f1f1f1" },
                                "& .MuiSelect-icon": { color: "#666" },
                                "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                            }}
                        >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={25}>25</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                        </Select>
                        <Typography sx={{ fontSize: "14px", fontWeight: 500, color: "#666" }}>
                            Showing {currentPage * pageSize + 1} to {Math.min((currentPage + 1) * pageSize, totalRecords)} out of {totalRecords} records
                        </Typography>
                    </Grid>

                    <Grid item sx={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "14px" }}>
                        {/* Backward Button */}
                        <IconButton
                            onClick={() => handlePageChange(null, currentPage)}
                            disabled={currentPage === 0}
                            sx={{
                                transition: "0.2s ease-in-out",
                                backgroundColor: "#f5f5f5",
                                color: "#444",
                                borderRadius: "6px",
                                padding: "5px",
                                "&:hover": { backgroundColor: "#e0e0e0" },
                                "&:disabled": { opacity: 0.4, backgroundColor: "#f5f5f5" },
                            }}
                        >
                            <ArrowBackIosNewIcon sx={{ fontSize: "16px" }} />
                        </IconButton>

                        {/* Serial Numbers */}
                        {serialNumbers.map((num, index) => (
                            <Box
                                key={index}
                                onClick={() => handlePageChange(null, num)}
                                sx={{
                                    width: "30px",
                                    height: "30px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "50%",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    backgroundColor: currentPage + 1 === num ? "#027BFE" : "transparent",
                                    color: currentPage + 1 === num ? "#fff" : "#222",
                                    // transition: "0.2s ease-in-out",
                                    "&:hover": { backgroundColor: currentPage + 1 === num ? "#027BFE" : "#f1f1f1" },
                                }}
                            >
                                {num}
                            </Box>
                        ))}

                        {/* Forward Button */}
                        <IconButton
                            onClick={() => handlePageChange(null, currentPage + 2)}
                            disabled={currentPage + 1 >= totalPages}
                            sx={{
                                // transition: "0.2s ease-in-out",
                                backgroundColor: "#f5f5f5",
                                color: "#444",
                                borderRadius: "6px",
                                padding: "5px",
                                "&:hover": { backgroundColor: "#e0e0e0" },
                                "&:disabled": { opacity: 0.4, backgroundColor: "#f5f5f5" },
                            }}
                        >
                            <ArrowForwardIosIcon sx={{ fontSize: "16px" }} />
                        </IconButton>
                    </Grid>
            </Box>
        </Fade>
    );
};

export default CustomPagination;
